<template>
  <div
    v-if="!removeFromDOM"
    class="jfpc"
    :class="themeClass"
    :publisher-component-id="id"
    :publisher-component-placement="componentPlacement"
    :instance-id="instanceId"
  >
    <div class="mb-2">
      <p class="font-medium text-xs">
        <span v-if="publisherAccountId == 10003">Sponsored Results For: </span>
        <span v-else>Ads Related To: </span>
        <span class="font-normal" style="font-style: italic">{{ keyword }}</span>
      </p>
    </div>

    <div v-if="loaded" class="standard-ads flex justify-center inline-grid gap-4 grid-cols-1 w-full">
      <tw-card
        v-for="(ad, i) in ads"
        :key="i + '_ad'"
        :ref="'standardAdsAd_' + i"
        class="standard-ads__ad-card h-auto"
        @click.native="isMobileUserAgent() && triggerAdClick(ad)"
        style="height: fit-content"
        v-bind="ad.container_attributes"
      >

        <div v-if="includeImage && ad.image_url.length > 0">
          <div>
            <span v-html="ad.title" class="font-bold text-base" @click="!isMobileUserAgent() && triggerAdClick(ad)" />
          </div>
          <div class="flex items-center space-x-4 mt-2">
            <tw-image :src="ad.image_url" :aspect-ratio="4/3" style="max-width: 60px;" no-background-color />

            <div class="min-w-0">
              <p class="text-sm">
                <span v-html="ad.description" @click="!isMobileUserAgent() && triggerAdClick(ad)" />
              </p>
            </div>
          </div>
          <div class="my-2 flex items-center text-gray-500 text-xs" @click="!isMobileUserAgent() && triggerAdClick(ad)">
            <icon-globe class="mr-1" size="12" />
            <p class="truncate" v-html="ad.host_url" />
          </div>
        </div>
        <div v-else>
          <div>
            <span v-html="ad.title" class="font-bold text-base" @click="!isMobileUserAgent() && triggerAdClick(ad)" />
            <div class="flex items-center space-x-4 mt-2 mb-4">
              <div class="min-w-0">
                <p class="text-sm">
                  <span v-html="ad.description" @click="!isMobileUserAgent() && triggerAdClick(ad)" />
                </p>
                <div class="mt-2 flex items-center text-gray-500 text-xs" @click="!isMobileUserAgent() && triggerAdClick(ad)">
                  <icon-globe class="mr-1" size="12" />
                  <p class="truncate" v-html="ad.host_url" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <tw-button label="See It" type="secondary" full-width @click.native="!isMobileUserAgent() && triggerAdClick(ad)" />
      </tw-card>
    </div>

    <div v-else class="flex justify-center grid gap-4 grid-cols-1">
      <tw-card v-for="i in perPage" :key="i + '_ad'" :ref="'standardAdsAdSkeleton_' + i">
        <div class="animate-pulse flex items-center space-x-4">
          <div class="w-full">
            <div class="h-3 bg-gray-300 rounded w-full" />
            <div class="h-3 bg-gray-300 rounded w-11/12 mt-2" />
            <div class="h-3 bg-gray-300 rounded w-10/12 mt-2" />
          </div>
        </div>
      </tw-card>
    </div>
  </div>
</template>

<script>
import PublisherBase from "@/mixins/Publisher/PublisherBase";
import AdsExtension from "@/mixins/Publisher/AdsExtension";
import TwCard from "@/components/Tailwind/TwCard.vue";
import TwButton from "@/components/Tailwind/TwButton.vue";
import IconGlobe from "@/components/Icon/IconGlobe.vue";
import TwImage from "@/components/Tailwind/TwImage.vue";


export default {
  name: "AdsStandard",
  components: {TwImage, IconGlobe, TwButton, TwCard},
  mixins: [
    PublisherBase,
    AdsExtension
  ],
  props: {
    ...PublisherBase.props,
    ...AdsExtension.props,
    includeImage: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      id: 19
    };
  },
  methods: {
    componentInit() {
      this.getAds();
    }
  }
}
</script>

<style src="@/styles/index.css" />

<style scoped></style>